import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';

import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';
import { VISITOR_IDS_STREAM } from '../../../streams';

export default connect(
  (state: AppState) => {
    const visitors = getUsersByIds(
      state,
      streamSelectors.getItems(state, VISITOR_IDS_STREAM)
    );
    const isOwner = isCurrentUserProfileOwner(state);
    return { visitors, isOwner };
  },
  {}
);
